import client from './AxiosClient'

const commissionService = {
    getAll : () => client.get("/commission"),
    create : (data) => client.post(`/commission`,data),
    update : (data) => client.put(`/commission`,data),
    getOrderCommission : (orderId) => client.get(`/order-commission?orderId=${orderId}`),
}

export default commissionService;